import React from 'react';
import { createStyles } from '@/contexts/theme-context';
import { Typography } from '@usepepper/ui/atoms/typography';
import { View } from 'react-native';

const EMPTY_STATE_TEXT_WIDTH = 300;

interface Props {
  bottomElement?: React.ReactNode;
  text: string;
}

export const DetailSectionEmptyState: React.FC<Props> = ({
  bottomElement,
  text,
}) => {
  const [styles, theme] = useStyles();

  return (
    <View style={styles.container}>
      <View style={styles.content}>
        <Typography
          color={theme.sk.color.text.secondary}
          textAlign="center"
          variant="paragraph-md"
        >
          {text}
        </Typography>
      </View>
      {bottomElement}
    </View>
  );
};

const useStyles = createStyles((theme) => ({
  container: {
    alignItems: 'center',
    borderColor: theme.sk.color.border.secondary,
    borderRadius: theme.sk.radii.radiusMedium,
    borderStyle: 'dashed',
    borderWidth: 1,
    gap: theme.sk.spacing.spaceSMedium,
    justifyContent: 'center',
    paddingVertical: theme.sk.spacing.spaceMedium,
  },
  content: {
    maxWidth: EMPTY_STATE_TEXT_WIDTH,
  },
}));
